/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SubscriptionStatus {
    ACTIVE = 'Active',
    CLOSED = 'Closed',
    CANCELLED = 'Cancelled',
    TERMINATED = 'Terminated',
}
